<section class="container-section" *ngIf="!isOpened">
  <div class="row">
    <div class="col-12 col-sm-12">
      <form class="needs-validation container-style" [formGroup]="formCostAdjustment">
        <div class="ps-2 pe-2">
          <div class="row pt-1">
            <div class="col">
              <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
                [width]="'6rem'" [routerLink]="['/', url]" [severity]="null"></app-custom-button>
            </div>
            <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
              <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
            </div>

            <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
              <app-custom-button [title]="'Imprimir'" [severity]="'contrast'" [icon]="'pi pi-print'"
                (onClick)="printPage()">
              </app-custom-button>
              <app-custom-button [title]="'Eliminar'" [severity]="'contrast'" [icon]="'pi pi-trash'"
                (onClick)="deleteCostAdjustment()"></app-custom-button>

              <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'"
                [width]="'5.5rem'" [severity]="'success'" [variant]="undefined"
                (onClick)="createNewRegister()"></app-custom-button>
            </div>
            <hr class="my-1">
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <app-custom-audit-info [userNameCreate]="costAdjustmentContract.userNameCreate"
                [createDate]="costAdjustmentContract.createDate"
                [userNameUpdate]="costAdjustmentContract.userNameUpdate"
                [updateDate]="costAdjustmentContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
            </div>
          </div>
          <div class="row d-flex justify-content-between">
            <div class="col-lg-7 col-md-6 col-sm-12 col-12 pe-lg-5 pe-md-2">
              <div class="row">
                <div class="col-lg-4 col-md-6 col-sm-5 col-12">
                  <app-custom-select formControlName="inventoryId" [labelText]="'Inventario'" [list]="listInventories"
                    [required]="true" [recovery]="true" (onChangeSelect)="changeInventory($event)"></app-custom-select>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-5 col-12">
                  <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                    [required]="true" [recovery]="true" (onChangeSelect)="changeBranch($event)"></app-custom-select>
                </div>
                <div class="col-lg-2 col-md-6 col-sm-2 col-6">
                  <app-custom-input-number formControlName="consecutive" [labelText]="'Número'" [required]="true"
                    [recovery]="true" (onChangeNumber)="changeConsecutive($event)"></app-custom-input-number>
                </div>
                <div class="col-lg-2 col-md-6 col-sm-2 col-6">
                  <app-custom-datepicker formControlName="dateCostAdjustment" [labelText]="'Fecha'"
                    [required]="true"></app-custom-datepicker>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-5 col-12">
                  <app-custom-autocomplete formControlName="providerId" [labelText]="'Proveedor'" [list]="listProviders"
                    [required]="true" (onChangeSelect)="changeProvider($event)"></app-custom-autocomplete>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-5 col-12">
                  <app-custom-autocomplete formControlName="inventoryEntryId" [labelText]="'Entrada'"
                    [list]="listInventoryEntries" (onChangeSelect)="changeinventoryEntry($event)">
                  </app-custom-autocomplete>
                </div>
              </div>
            </div>
            <div class="col-lg-5 col-md-6 col-sm-12 col-12">
              <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-2 col-6">
                  <app-custom-tag [label]="'Estado'" [severity]="severityState" [value]="stateText"></app-custom-tag>
                </div>
                <div class="col-lg-1 col-md-1 col-sm-1 col-1 d-flex align-items-end justify-content-center">
                  <app-custom-button [icon]="icon" [title]="titleState" [severity]="'primary'"
                    (onClick)="changeStateCostAdjustment()"></app-custom-button>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 col-6">
                  <app-custom-input-text formControlName="remission" [labelText]="'Remisión'" [maxLength]="15">
                  </app-custom-input-text>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 col-6">
                  <app-custom-input-text formControlName="invoice" [labelText]="'Factura'" [maxLength]="15">
                  </app-custom-input-text>
                </div>
                <div class="col-lg-10 col-md-11 col-sm-12 col-12">
                  <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [rows]="1"
                    [autoResize]="false" [maxLength]="250"></app-custom-textarea>
                </div>
                <div
                  class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end align-items-end mt-sm-2  mt-2">
                  <app-custom-button [disabled]="disabledForm" [label]="'Guardar'" [severity]="'primary'"
                    [variant]="undefined" (onClick)="send()"></app-custom-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <app-cost-adjustment-detail [disabledDetail]="disabledDetail" [costAdjustmentModel]="costAdjustmentContract"
      [permissionUpdatable]="permissionUpdatable" (emitQuantityDetails)="quantityDetails = $event">
    </app-cost-adjustment-detail>
  </div>
</section>
<!-- Imprimir Ajuste Costos -->
<app-print-cost-adjustment id="print-cost-adjustment" [companyId]="companyId" [formatModel]="formatModel"
  [costAdjustmentPrintModel]="costAdjustmentPrintModel" [editFormat]="false" [focusText]="false"
  (finishLoadingPrint)="finishLoading($event)">
</app-print-cost-adjustment>

<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{ nameWindow }} abiertas.</h6>
</div>